import React from 'react';
import { useTranslation } from 'react-i18next';
import ShopSyncedMaterialListPage from '@/temu-platform/modules/templates/ShopSyncedMaterialListPage';

/** 模板库 · 模特库：店铺平台同步 + 新建/编辑（发品仅可选已同步到平台的模特） */
export default function ModelTemplatePage() {
  const { t } = useTranslation('workbench');
  return (
    <ShopSyncedMaterialListPage
      kind="model"
      libraryLabel={t('modelLib.library')}
      idColumnLabel={t('modelLib.colId')}
      nameColumnLabel={t('modelLib.colName')}
      syncHint={t('modelLib.syncHintTemu')}
    />
  );
}
